import service from '../../utils/service'
import Urls from '../../utils/urlStrings'
import { MICROSERVICES } from '../../utils/constants'

export class RequestService {
  async getAllRequests(account_id, params) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${account_id}/user/signupRequestsStatus`, MICROSERVICES.SESSIONMANAGER), { params: params })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async approveRequest(params, account_id) {
    const { email, approval_status } = params
    try {
      const response = await service.post(Urls.getApiUrl(`admin/${account_id}/user/approve`, MICROSERVICES.SESSIONMANAGER), { email }, { params: { approval_status } })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async rejectRequest(params, account_id) {
    const { email, approval_status } = params
    try {
      const response = await service.post(Urls.getApiUrl(`admin/${account_id}/user/approve`, MICROSERVICES.SESSIONMANAGER), { email }, { params: { approval_status } })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }
}

export const requestService = new RequestService()
